export default class ContentBlock {
	constructor(block) {
		this._type = block.type;
	}

	type() {
		return this._type;
	}
}
